import z from 'zod';
export const invoiceNumberValue = z
    .string()
    .trim()
    .min(1)
    .brand('InvoiceNumber');
export const createInvoiceNumber = (value) => invoiceNumberValue.parse(value);
export const isInvoiceNumber = (value) => invoiceNumberValue.safeParse(value).success;
//# sourceMappingURL=invoice-number.js.map